import dayjs from 'dayjs';

export const CurrentTimestamp = () => {
     return Math.round(new Date().getTime() / 1000);
};

export const formatTime = (text, format) => {
     return dayjs(text).format(format);
};

class DateUnix {
     public now() {
          return Math.round(new Date().getTime() / 1000);
     }

     public formatDate(dateToFormat) {
          const date = new Date(dateToFormat);

          const monthNames = [
               'January',
               'February',
               'March',
               'April',
               'May',
               'June',
               'July',
               'August',
               'September',
               'October',
               'November',
               'December',
          ];

          const day = date.getDate();
          const monthIndex = date.getMonth();
          const year = date.getFullYear();

          return `${day} ${monthNames[monthIndex]} ${year}`;
     }

     public parse(date) {
          // @ts-ignore
          return Math.round(new Date().parse(date) / 1000);
     }
}

export default new DateUnix();
